import React from 'react';
import {Upload, Review, Errors, Success} from 'components/forms/sections';
import {Route} from 'react-router-dom';
import ProgressForm from 'components/forms/ProgressForm';
import {FormNames, FormTypes} from '../../../constants';
import {StatePrompt} from 'components/forms';
import fields from './fields';
import {
    Signature,
    Loadings,
    Discharges,
    CommencementLoadings,
    CompletionLoadings,
    CommencementDischarges,
    CompletionDischarges,
    AssociateSsl,
} from './sections';
import {Branch, BranchGroup} from 'components/forms/navigation';

const FormTankerman = () => {
    const node = FormTypes.TANKERMAN.toLowerCase();
    const urlBase = `/forms/${node}/`;

    return (
        <ProgressForm title={FormNames.TANKERMAN} node={node}>
            <StatePrompt />
            <Route path={urlBase + 'upload'}>
                <Upload documentType={node} />
            </Route>
            <Route path={urlBase + 'signature'}>
                <Signature />
            </Route>
            <Route path={urlBase + 'loadings'}>
                <Loadings />
            </Route>
            <Route path={urlBase + 'discharges'}>
                <Discharges />
            </Route>
            <Route path={urlBase + 'commencement-loadings'}>
                <CommencementLoadings />
            </Route>
            <Route path={urlBase + 'completion-loadings'}>
                <CompletionLoadings />
            </Route>
            <Route path={urlBase + 'commencement-discharges'}>
                <CommencementDischarges />
            </Route>
            <Route path={urlBase + 'completion-discharges'}>
                <CompletionDischarges />
            </Route>
            <BranchGroup>
                <Branch when={{
                    field: '_ssl_attached',
                    value: 'true',
                    comparitor: '==='
                }}>
                    <Route path={urlBase + 'ssl'}>
                        <AssociateSsl />
                    </Route>
                </Branch>
            </BranchGroup>
            <Route path={urlBase + 'review'}>
                <Review
                    showFormInfo
                    fields={fields}
                    isEnd
                    endpointOverride='tankerman'
                />
            </Route>
            <Route path={urlBase + 'errors'}>
                <Errors />
            </Route>
            <Route path={urlBase + 'success'}>
                <Success />
            </Route>
        </ProgressForm>
    );
};

export default FormTankerman;
